import { isElongUserIdByCookie, wrapAuthorizeUrl } from '@common-libs/tj-channel/elong'
import * as tjChannel from '@common-libs/tj-channel'
import { queryString, getQueryStrByObj, urlAppendQuery } from '@common-libs/utils/url-helper'
import { getPlatform } from '@common-libs/tj-utils/platform'
import { asyncLoadScript } from '@common-libs/utils/dom-helper'
import { mpUtils } from '@tujia/fe-lib-bridge/lib'
import tjCookie from '@/utils/tjCookie'
import { tjStorage } from '@tujia/fe-lib-common'
import commonApi from '@/services/commonApi'
// import tjCheckDate from '@/business/tjCheckDate'
import { Toast } from '@tujia/tj-mob-ui'

const host = process.host
const CODE_ELONG_ORDER_LIST = 'ylysddlbrk'

// 环境枚举
const ENV_ENUM = { TAPP: 'tapp', EAPP: 'eapp', EAPPLET: 'eapplet', UNKNOW: 'unknow' }

/**
 * 获取各交互数据时用到的key
 * @param {String} keyType 数据交互类型
 * @returns {String}
 */
export function getPostMessageKey(keyType) {
  const KEY_ENUM = {
    // 一框
    citySuggestSelected: {
      app: 'minsu_tujiaCitySuggestSelected',
      mp: 'home_hotel_tujia'
    },
    // 二框
    keywordSuggestSelected: {
      app: 'minsu_tujiaKeywordSuggestSelected',
      mp: 'home_hotel_tujia'
    },
    // 其他筛选：钻级、价格
    filterSelected: {
      app: 'minsu_tujiaCdsFilterSelected',
      mp: 'minsu_tujiaCdsFilterSelected'
    },
    // 清空
    clearStandardName: {
      app: 'minsu_tujiaClearStandardName',
      mp: 'home_hotel_tujia'
    }
  }
  if (!KEY_ENUM[keyType]) {
    return ''
  }
  if (getPlatform().isTEAppEnv) {
    return KEY_ENUM[keyType].app
  } else {
    return KEY_ENUM[keyType].mp
  }
}
/**
 * 获取当前运行环境
 */
export function getClientType() {
  if (getPlatform().isMpEnv) {
    return ENV_ENUM.EAPPLET
  } else if (getPlatform().isTongchengAppEnv) {
    return ENV_ENUM.TAPP
  } else if (getPlatform().isElongAppEnv) {
    return ENV_ENUM.EAPP
  } else {
    return ENV_ENUM.UNKNOW
  }
}

/**
 * 检查是否 elong channel
 */
export function isElongChannel() {
  return tjChannel.getChannelInfo().isElong
}

/**
 * 检查 elong token
 */
export function checkElongToken() {
  const newToken = queryString('elongToken')
  const oldToken = tjCookie.getChannelToken()
  if (newToken) {
    tjCookie.setChannelToken(newToken)
    tjCookie.setOpenId(tjChannel.getChannelToken().openId)
  }
  return {
    newToken,
    oldToken
  }
}

/**
 * 登陆检查，未携带elongToken进入页面时唤起登陆
 * 应尽量避免使用该方法，会对数据上报产生影响。
 * 未登录为游客模式浏览
 */
export async function checkElongAppLogin(callBack) {
  if (getPlatform().isTEAppEnv) {
    try {
      let _cookies = tjCookie.getCookieTransfromObject()

      let sessionToken = ''

      if (window.FlexBridge) {
        let elongLoginInfo = await window.FlexBridge.getAccount()
        if (elongLoginInfo?.isLogin) {
          sessionToken = elongLoginInfo?.sessionToken || elongLoginInfo?.memberIdNew || ''
        } else {
          const result = await window.FlexBridge.loginAccount()
          sessionToken = result?.isLogin ? (result?.sessionToken || result?.memberIdNew) : ''
        }
      }

      if (sessionToken) {
        /** 由于艺龙登陆后会清除所有cookie, 这里得恢复cookie信息 ***/
        const keysCookie = Object.keys(_cookies)
        for (let item in keysCookie) {
          if (keysCookie[item].indexOf('Context_UserId') > -1 ||
            keysCookie[item].indexOf('Context_UserToken') > -1 ||
            keysCookie[item].indexOf('Context_EndDate') > -1 ||
            keysCookie[item].indexOf('Context_StartDate') > -1 ||
            keysCookie[item].indexOf('_fas_uuid') > -1
          ) {
            continue
          } else if (keysCookie[item].indexOf('clientAgent') > -1) {
            tjStorage.setCookieByDomain('clientAgent', _cookies[keysCookie[item]], 30, true)
          } else if (keysCookie[item].indexOf('tujia_code') > -1) {
            tjCookie.setTujiaCode(_cookies[keysCookie[item]])
          } else if (keysCookie[item].indexOf('tj_channel_wrapper_id') > -1) {
            tjCookie.setChannelWrapperId(_cookies[keysCookie[item]])
          } else if (keysCookie[item].indexOf('tj_open_id') > -1) {
            tjCookie.setOpenId(_cookies[keysCookie[item]])
          } else if (keysCookie[item].indexOf('tj_channel_id') > -1) {
            tjCookie.setChannelId(_cookies[keysCookie[item]])
          } else if (keysCookie[item].indexOf('tj_location_lat_lon') > -1) {
            tjStorage.setCookieByDomain('tj_location_lat_lon', _cookies[keysCookie[item]], 7, true)
          } else if (keysCookie[item].indexOf('tj_abtest') > -1) {
            tjStorage.setCookieByDomain('tj_abtest', _cookies[keysCookie[item]], 1, true)
          } else {
            tjStorage.setCookieByDomain(keysCookie[item], _cookies[keysCookie[item]], '', true)
          }
        }
        // 转换为途家用户信息 同时写入cookie
        let _status = await TransformTokenEtoT(sessionToken)

        if (_status) {
          callBack && callBack()
        } else {
          Toast.fail('登陆处理失败')
        }
        return _status
      } else {
        Toast.fail('未完成登陆')
        setUserVisitor()
      }
      return false
    } catch (e) {
      Toast.fail('未完成登陆')
      setUserVisitor()
      return false
    }
  } else {
    return false
  }
}

export async function TransformTokenEtoT(sessionToken) {
  // 加载三方登陆
  const res = await commonApi.thirdChannelLogin({
    channel: 'elong',
    tokenData: {
      accessToken: sessionToken
    },
    platformType: getClientType()
  })
  let flag = false
  if (res?.isSuccess) {
    if (res?.data?.userID && res?.data?.userToken) {
      flag = true
      // 服务端数据返回了用户信息，但是Cookie存在未写入，手动写入
      tjCookie.setUserId(res.data.userID)
      tjCookie.setUserToken(res.data.userToken)

      // 登陆成功 uuid设置为历史uuid 保持uuid的一致性
      let uuid = tjCookie.getDeviceId()
      // app or h5 时， uuid优先使用backup替换VISITOR999999
      if (!getPlatform().isMpEnv) {
        let backupUUID = tjCookie.getUUIDBackUp()
        if (uuid === 'VISITOR999999') {
          if (backupUUID && backupUUID !== 'VISITOR999999') {
            uuid = backupUUID
          } else {
            uuid = getUUID()
          }
        }
      }
      let { isSuccess, data } = await commonApi.getPrimaryUUid()
      if (isSuccess && data.uid && data.uid !== uuid) {
        uuid = data?.uid
      }
      tjCookie.setDeviceId(uuid)
      // 更新埋点uid
      window._fas.globalUUID = uuid
      window._fas.siteInfo.uid = uuid

      // 加埋点监控uuid被更新
      // eslint-disable-next-line no-unused-expressions
      window._fas && window._fas.setCustomTrack({
        eventName: 'UUID',
        data: {
          type: 'transformed',
          newUUID: uuid
        }
      })
    } else {
      setUserVisitor()
      // 三方联合登陆，cookie 未返回正常登陆，报异常
      window._fas && window._fas.setCustomError({ message: `third_channel_login_error_no_user_info`, error: res })
    }
  } else {
    setUserVisitor()
    // 清空 token 值
    tjCookie.setChannelToken('')

    // 记录异常
    window._fas && window._fas.setCustomError({ message: `third_channel_login_error`, error: res })
  }
  return flag
}

/**
 * 登陆下有几个逻辑，能进来 一定是 elong 渠道，下面所有流程 都是判定了是 elong 渠道下处理
 * 1. 同程艺龙app
 *    通过api检测app登陆状态
 * 2. 小程序 or h5
 *    URL 有  token
 *    1.1 判定缓存是否一致，不一致强登陆
 *    1.2 一致下，不是 elong 的userId 否则需要重新登陆
 *    URL 无  token
 *    1.1 判定当前是否是小程序环境
 *        如果不是的话  强制清空 elong 相关 cookie。
 *        是小程序环境  检测userid 是都是艺龙端的， 否则
 * **/
export async function elongLogin() {
  const elongTokens = checkElongToken()
  // 返回登陆状态信息
  let returnFlag = { isSuccess: true }
  let platformInfo = getPlatform()
  // 艺龙app  或者同程app url不带token
  if (platformInfo.isTEAppEnv) {
    /** app 是否未登陆
     *  未登陆 清空途家域名的user信息
     *  已登陆 则转换途家登陆信息
     */
    let elongLoginInfo = {}
    // FlexBridge.js未成功加载
    if (window.FlexBridge && window.FlexBridge.getAccount) {
      let info = await window.FlexBridge.getAccount()

      elongLoginInfo = {
        isLogin: info?.isLogin,
        sessionToken: info?.sessionToken || info?.memberIdNew || ''
      }
    } else if (window.FlexBridge && window.FlexBridge.loginAccount) {
      let result = await window.FlexBridge.loginAccount()

      elongLoginInfo = {
        isLogin: result?.result || false,
        sessionToken: result?.isLogin ? (result?.sessionToken || result?.memberIdNew) : ''
      }
    } else {
      if (!isElongUserIdByCookie()) {
        setUserVisitor()
      } else {
        // 认为历史token 是有效登陆
        // return returnFlag
      }
    }

    if (!elongLoginInfo?.isLogin) {
      setUserVisitor()
    } else {
      let sessionToken = elongLoginInfo?.sessionToken || ''
      if (sessionToken) {
        // 转换为途家用户信息 同时写入cookie
        let _status = await TransformTokenEtoT(sessionToken)
        if (!_status) {
          returnFlag.isSuccess = false
        }
      }
    }
  } else if (elongTokens.newToken) {
    // 艺龙 小程序、 浏览器 h5、同程app
    if (elongTokens.newToken !== elongTokens.oldToken || !tjCookie.getUserInfo() || !isElongUserIdByCookie()) {
      let accessToken = ''
      // 解析参数
      try {
        const tokenData = JSON.parse(decodeURIComponent(elongTokens.newToken))

        accessToken = tokenData.sessionToken
        // 异常返回数据判定
        if (tokenData.errorCode || !accessToken) {
          window._fas && window._fas.setCustomError({ message: `elong_channel_token_auth_error ${tokenData.errorCode}`, error: { elongTokens } })
          returnFlag = { isSuccess: false, errorNo: -1, errorMsg: `登陆授权异常，请重试：${tokenData.errorMessage || 'elong_channel_token_auth_error'}` }
          return returnFlag
        }
      } catch (error) {
        window._fas && window._fas.setCustomError({ message: `elong_channel_token_parse_error`, error: { elongTokens } })
        returnFlag = { isSuccess: false, errorNo: -1, errorMsg: 'elong_channel_token_parse_error_parse' }
        return returnFlag
      }
      // 把elong登录态转换为途家登录信息
      const flag = await TransformTokenEtoT(accessToken)
      if (!flag) {
        returnFlag = { isSuccess: false, errorNo: -1, errorMsg: 'elong_channel_token_parse_error_tran' }
        return returnFlag
      }
    }
  } else {
    if (getPlatform().isMpEnv && queryString('tjchannelid')) {
      if (!queryString('redirectByAuth')) {
        returnFlag = { isSuccess: false, errorNo: -1, errorMsg: 'elong_channel_token_parse_error_tjchannelid' }
        window.location.replace(wrapAuthorizeUrl(urlAppendQuery(window.location.href, { redirectByAuth: 1 })))
        return returnFlag
      }
      window._fas && window._fas.setCustomError({ message: `elong_channel_token_unknown_error`, error: {} })
    }

    if (!isElongUserIdByCookie()) {
      // 清空 elong 相关信息
      tjChannel.clearCookieChannelInfo()
      // document.body.classList.remove('tj-channel-elong')

      if (getPlatform().isMpEnv) {
        returnFlag = { isSuccess: false, errorNo: -1, errorMsg: 'elong_channel_token_parse_error' }
      } else {
        setUserVisitor()
        returnFlag.isSuccess = true
      }
    }
  }
  return returnFlag
}

/**
 * 艺龙支付跳转
 * @param {} param.token 支付token
 * @param {} param.tradeNo 支付号
 * @param {} param.jumpToAddr 跳转地址
 */
export function elongPay({ token, tradeNo }) {
  const elongTokenData = tjChannel.getChannelToken()
  window.location.href = `${host.M_TUJIA_HOST}/feapi/pay-cashier/api/getCashierUrl.do?token=${token}&payTradeNo=${tradeNo}&bizChannelType=2&needJump=1&openId=${elongTokenData.openId}`
}

/**
 * 艺龙回调数据组装 APP
 * @param {} param.method 标志key
 * @param {} param.arguments suggest数据
 */
export function postAppMessage(param) {
  if (window.FlexBridge) {
    window.FlexBridge.hotelCommonBusiness(param)
  }
}

/**
 * 艺龙mp page返回
 *
 */
export function mpBack() {
  mpUtils.navigateBack({
    delta: 1
  })
}

/**
 * TEAPP 关闭Webview
 * 清除cookie
 */
export function closeWebView() {
  /** 回退到艺龙端 需要清除cookie */
  setUserVisitor()
  tjCookie.setChannelId('')
  tjCookie.setChannelWrapperId('')
  tjCookie.setTujiaCode('')
  tjCookie.setTujiaCodeSite('')
  window.FlexBridge && window.FlexBridge.closePage()
  return false
}

// 设置当前访问模式为访客
function setUserVisitor() {
  tjCookie.setUserId('')
  tjCookie.setUserToken('')
  if (tjChannel.getChannelInfo().isElong && !getPlatform().isMpEnv) {
    let uuid = tjCookie.getDeviceId()
    if (uuid !== 'VISITOR999999' || !uuid) {
      tjCookie.setCookieByDomain('_fas_uuid_backup', uuid, 365)
    }
    tjCookie.setDeviceId('VISITOR999999')
    window._fas.globalUUID = 'VISITOR999999'
    window._fas.siteInfo.uid = 'VISITOR999999'
  }
}

/**
 * Elong渠道后退逻辑
 */
export function closeOrBack() {
  if (getPlatform().isTEAppEnv) {
    closeWebView()
  } else if (getPlatform().isMpEnv) {
    mpBack()
  }
}

/**
 * 艺龙mp 二框清除
 *
 */
export function clearSecondBankVal(item) {
  postMessage('clearStandardName', item)
}

// function getShareConfig({ title, path, imageUrl }) {
//   const checkDate = tjCheckDate.getCheckDateCookieByCookieStr(false, document.cookie)
//   const beginDateStr = checkDate.beginDate.toString('yyyy-MM-dd')
//   const endDateStr = checkDate.endDate.toString('yyyy-MM-dd')

//   const shareParams = {
//     ssr: 'off',
//     tjchannelid: 'elong',
//     code: `elong_${getClientType()}_share`,
//     checkInDate: beginDateStr,
//     checkOutDate: endDateStr
//   }
//   if (window._fas) {
//     const traceId = window._fas.getTraceId()
//     shareParams._fasTraceId = `${getClientType()}_share_${traceId}`
//   }

//   const shareParamsStr = getQueryStrByObj(shareParams)
//   // 如果没传url， 默认分享首页
//   path = path || `${host.M_TUJIA_HOST}`
//   let defaultPath = `${path}?${shareParamsStr}`
//   let defaultTitle = title || `${getPlatform().isElongAppEnv ? '艺龙' : '同程'}旅行民宿公寓预订`
//   let defaultImageUrl = imageUrl || `https://pic.tujia.com/upload/festatic/publicImages/TEAPP_share_default_${getClientType()}.jpg`
//   return { defaultPath, defaultTitle, defaultImageUrl }
// }

/**
 * 直接回首页
 */
export function elongGoBackToHomePage() {
  if (getPlatform().isTEAppEnv && window.FlexBridge) {
    window.FlexBridge.closePage()
    return false
  }

  if (getPlatform().isMpEnv) {
    // 艺龙订单列表进来的 需要直接 back
    if (tjCookie.getTujiaCode() === CODE_ELONG_ORDER_LIST) {
      mpBack()
    } else {
      mpUtils.goMpHomePage()
    }
  }
}

/**
 * 拦截跳转到elong民宿首页
 */
export function elongPageHookBackToHomePage() {
  history.pushState(null, null, document.URL)
  window.addEventListener('popstate', () => {
    elongGoBackToHomePage()
  })
}

/**
 * 埋点相关
 */
export function includeFasScript() {
  if (!window._xlog && isElongChannel()) {
    asyncLoadScript('https://m.elongstatic.com/xlog/tujia/v0.5/index.js')
  }
}

export function includeFBScript() {
  if (!getPlatform().isMpEnv && isElongChannel()) {
    asyncLoadScript('https://m.elongstatic.com/flexbridge/sdk/3.8.6/flexbridge.js', true)
      .then(() => {
        // elongAPP目前暂时无法只分享小程序， 先屏蔽分享功能，后续支持后放开
        if (getPlatform().isTongchengAppEnv) {
          window.FlexBridge.showHeaderShareIcon()
        }
      })
  }
}

export async function setTEAPPShare(shareConfig) {
  const FlexBridge = window.FlexBridge
  if (!FlexBridge) {
    return false
  }
  const defaultShareConfig = {
    title: document.title,
    path: location.origin + location.pathname
  }
  // 打开APP原生头部的右侧分享按钮
  const { defaultPath, defaultTitle, defaultImageUrl } = getShareConfig(shareConfig || defaultShareConfig)
  const wxSharePath = `/page/home/webview/webview?src=${encodeURIComponent(wrapAuthorizeUrl(defaultPath))}`
  try {
    await FlexBridge.share({
      img: defaultImageUrl,
      link: defaultPath,
      onlyShowShareBtn: true,
      title: defaultTitle,
      platform: 0,
      wxShareType: 0,
      miniProgramPath: wxSharePath,
      miniProgramTitle: defaultTitle,
      miniProgramWebPageURL: wrapAuthorizeUrl(defaultPath),
      useMiniProgram: 1,
      wxAppInfo: {
        wxUserName: 'gh_0a00573ff7cf',
        wxPath: wxSharePath
      },
      tcsharetype: 'true',
      shareType: 'haoyou'

    })
  } catch (e) {
    console.log(e)
  }
}

function track(key, data) {
  if (window._xlog) {
    window._xlog.send(key, data)
  } else {
    window.addEventListener('_xlogLoaded', () => {
      window._xlog.send(key, data)
    })
  }
}
/**
 * 发送 pv
 */
export function trackPv() {
  track('timing')
}
/**
 * 发送点击创建订单埋点
 * @param {*} param0
 */
export function trackPostOrder({ hotelId }) {
  track('postOrder', { hotelid: hotelId })
}
/**
 * 发送创建订单成功埋点
 * @param {} param.hotelId
 * @param {} param.orderNo
 */
export function trackCreateOrderSuccess({ hotelId, orderNo }) {
  track('createOrderSucc', { hotelid: hotelId, orderno: orderNo })
}

/**
 * 发送创建订单成功埋点
 * @param {} param.hotelId
 * @param {} param.errorCode
 * @param {} param.errorMessage
 */
export function trackCreateOrderFail({ hotelId, errorCode, errorMessage }) {
  track('createOrderFail', { hotelid: hotelId, errorCode, errorMessage })
}

/**
 * 获取艺龙收银台信息失败
 * @param {*} param.token 订单 token
 * @param {*} param.tradeNo 订单号
 * @param {*} param.errMsg 获取收银台接口失败信息
 */
export function trackGetCashierFail({ token, tradeNo, errMsg }) {
  track('getCashierFail', { token, tradeNo, errMsg })
}

/**
 * 生成与原生首页交互的数据结构
 * @param {string} key key
 * @param {object} value 数据内容
 * @returns {type} 返回值描述
 */
export function postMessageFormat(key, value) {
  // MP 交互数据结构
  if (getPlatform().isMpEnv) {
    return {
      data: {
        homeOpt: {
          from: key,
          data: value
        }
      }
    }
  }
  // APP 交互数据结构
  if (getPlatform().isTEAppEnv) {
    return {
      method: key,
      arguments: value
    }
  }
}

export function getGUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0
    let v = c === 'x' ? r : (r & 0x3) | 0x8 // tslint:disable-line
    return v.toString(16)
  })
}

/**
 * UUID
 */
 export function getUUID() {
  let uuid = getGUID() + '-' + new Date().getTime()
  return uuid
}
